module.exports = __webpack_public_path__ + "static/fonts/OpenSans300.f51d593e.ttf";